module.exports = __webpack_public_path__ + "img/recording_img.64eec4ae.png";